import { Download, Loader2 } from "lucide-react";

import { Button } from "@/components/ui/button";

/** The one Export trigger used by every tool; opens the shared Export dialog. */
export function ExportButton({
  onClick,
  disabled,
  busy = false,
}: {
  onClick: () => void;
  disabled?: boolean;
  /** An export is generating; the button stays usable to check on it. */
  busy?: boolean;
}) {
  return (
    <Button type="button" variant="outline" size="sm" onClick={onClick} disabled={disabled} aria-label="Export">
      {busy ? <Loader2 className="animate-spin" /> : <Download />}
      <span className="hidden sm:inline">Export</span>
    </Button>
  );
}
